var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('Header',{attrs:{"hot":_vm.hot}}),_c('div',[_c('router-view')],1),_c('Footer',{attrs:{"hot":_vm.hot}}),_c('Service',{attrs:{"hot":_vm.hot}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }